import React from 'react';
import { Typography, Button } from '@mui/material';

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Typography variant="h1" className="mb-4">404</Typography>
      <Typography variant="h4" className="mb-4">Page Not Found</Typography>
    </div>
  );
};

export default NotFound;